import { useQuery } from 'react-query';

import { getSBSMonitoring } from 'api/reports/getSBSMonitoring';

export const useGetSBSMonitoring = (
  slug: string,
  start_date: string,
  end_date: string,
  filterType: string,
  enabled: boolean = true,
) => {
  const { data, refetch, isRefetching, isLoading } = useQuery(
    'sbsMonitoring',
    () => getSBSMonitoring(slug, start_date, end_date, filterType),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return { data, refetch, isRefetching, isLoading };
};

export default useGetSBSMonitoring;
